import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Grid,
  // useMediaQuery,
} from '@mui/material';

import { styled, createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import { USER_SERVER, ORGANIZATION_SERVER } from '../../Config';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';

import * as Yup from 'yup';
import axios from 'axios';
axios.defaults.withCredentials = true;

const theme = createTheme({
  main: 'rgba(0, 0, 0, 0.6)',
  orange: orange[500],
});

const CustomGrid2 = styled(Grid)({
  height: '80px',
});

const CustomTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});
const CustomFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});

const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  phonenumber: Yup.string().matches(phoneRegExp, {
    message: 'Phone number is not valid',
    excludeEmptyString: true,
  }),
});

export default function ManageMemberDialog(props) {
  const [groupList, setGroupList] = useState([]);
  const user = useSelector((state) => state.user.userData);

  const onSubmit = async (data, e) => {
    // async request which may result error
    try {
      axios.patch(`${process.env.REACT_APP_SERVER}${USER_SERVER}/manageuser`, data).then((res) => {
        props.handleClose(e);
        enqueueSnackbar('Member Update Completed.', {
          variant: 'success',
          autoHideDuration: 2500,
        });
      });
    } catch (e) {
      // handle your error
    }
  };

  const {
    handleSubmit,
    register,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      _id: '',
      email: '',
      name: '',
      group: '',
      role: '',
    },
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (props.open) {
      axios
        .get(`${process.env.REACT_APP_SERVER}${ORGANIZATION_SERVER}/list`)
        .then((res) => {
          // console.log(res.data);
          setGroupList(res.data);
        })
        .then(() => {
          axios.get(`${process.env.REACT_APP_SERVER}${USER_SERVER}/manageuser/${props.userId}`).then((res) => {
            reset(res.data);
          });
        });
    }
  }, [props]);

  return (
    <Dialog component="form" open={props.open} onClose={props.handleClose} onSubmit={handleSubmit(onSubmit)}>
      <DialogTitle variant="h5">Manage User</DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'end',
            alignItems: 'flex-end',
          }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <CustomTextField
              disabled
              fullWidth
              variant="filled"
              label="ID (Email)"
              size="small"
              autoComplete="email"
              {...register('email')}
              value={watch('email') || ''}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <CustomFormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="role-label">Role</InputLabel>
              <Select
                labelId="role-label"
                id="role"
                fullWidth
                label="Role"
                // disabled={!user.userData.isAdmin}
                {...register('role')}
                value={watch('role') || ''}
              >
                <MenuItem value={'user'}>User</MenuItem>
                <MenuItem value={'admin'}>Admin</MenuItem>
                {/* <MenuItem value={'super admin'}>Super Admin</MenuItem> */}
              </Select>
            </CustomFormControl>
          </Grid>
          <CustomGrid2 size={{ xs: 12, sm: 6 }}>
            <CustomTextField
              // required
              fullWidth
              variant="standard"
              label="Name"
              autoComplete="name"
              {...register('name')}
              value={watch('name') || ''}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              size="small"
            />
          </CustomGrid2>

          <CustomGrid2 size={{ xs: 12, sm: 6 }}>
            <CustomTextField
              // required
              fullWidth
              variant="standard"
              label="Contact"
              name="phonenumber"
              {...register('phonenumber')}
              value={watch('phonenumber') || ''}
              error={Boolean(errors.phonenumber)}
              helperText={errors.phonenumber?.message}
              size="small"
            />
          </CustomGrid2>
          <CustomGrid2 size={12}>
            <CustomFormControl variant="outlined" fullWidth>
              <InputLabel shrink>Ogranization</InputLabel>
              <Select
                // disabled={!user.userData.isAdmin}
                label="Ogranization"
                name="group"
                fullWidth
                size="small"
                {...register('group')}
                value={watch('group') || ''}
                disabled={user.role !== 'super admin'}
              >
                {groupList &&
                  groupList.map((group) => {
                    return (
                      <MenuItem key={group._id} value={group._id}>
                        {`${group.name} ${group.projectName ? `- ${group.projectName}` : ''}`}
                      </MenuItem>
                    );
                  })}
              </Select>
            </CustomFormControl>
          </CustomGrid2>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="outlined" onClick={props.handleClose} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          // onClick={handleSubmit(onSubmit)}
          type="submit"
          size="small"
          variant="contained"
          color="error"
          sx={{ textTransform: 'none' }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
